var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-2",attrs:{"loading":_vm.loading,"disabled":_vm.loading,"href":_vm.link,"target":"_blank","text":"","color":"primary"}},[_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("mdi-download")]),_vm._v(" Baixar ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }